import * as React from 'react'
import classnames from 'classnames'
import { Button, Icon } from '@atoms'

import { Dropdown } from '../../../common/Dropdown/Dropdown'

import { Option } from '../types'
import { SelectProps } from './types'
import { SelectOptions } from './SelectOptions'
import { useDropdownClickOutside } from '../../Dropdown/useDropdownClickOutside'

export const Select: React.FC<SelectProps> = (props) => {
    const {
        label,
        value,
        onChange: onChangeCallback,
        verticalAlign,
        horizontalAlign,
        ...rest
    } = props
    const [isOpen, setIsOpen] = React.useState(false)

    const selectedOptionLabel =
        rest.options.find((option) => option.value === value)?.label || label

    const { buttonRef, dropdownRef } = useDropdownClickOutside(() => {
        if (isOpen) {
            setIsOpen(false)
        }
    })

    const toggle = () => {
        setIsOpen((isOpen) => !isOpen)
    }

    const passedProps = {
        isOpen,
        onClick: toggle,
        dropdownRef,
    }

    const disabled = rest.disabled

    const onChange = (newValue: Option['value']) => {
        onChangeCallback(newValue)
        toggle()
    }

    const dropdownClassname = classnames('py-2', props.dropdownClassname)

    return (
        <Dropdown
            name="select-dropdown"
            buttonProps={{
                disabled,
                variant: 'outlineSecondary',
                size: 'large',
                name: `${rest.name}-dropdown-button`,
                className: 'whitespace-nowrap',
                children: (
                    <>
                        {selectedOptionLabel}{' '}
                        <Icon size="small" name="keyboard_arrow_down" />
                    </>
                ),
                buttonRef,
            }}
            buttonComponent={Button}
            verticalAlign={verticalAlign}
            horizontalAlign={horizontalAlign}
            data-testid={rest.name}
            dropdownClassname={dropdownClassname}
            {...passedProps}
        >
            <SelectOptions value={value} onChange={onChange} {...rest} />
        </Dropdown>
    )
}
